import { fulfillmentTransactionIsValid } from "services/sosInventoryService/fulfillmentTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";

export function isValid(record, relatedRecords, lines) {
  let errors = fulfillmentTransactionIsValid(record, relatedRecords, lines);
  errors = quantitySerialsIsValid(errors, lines);
  return errors;
}
